import { bridge_getDeviceModel } from '../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { isSDKCompatible } from '../VNAndroidSDK/Utils'
import { DEVICE_MODEL } from '../VNMode/Utils'

const MIN_REFUND_RECEIPTS_APK_VERSION = '2.19.0'

export const refundReceiptsEnabled = (androidSDKVersion) => {
  if (DEVICE_MODEL.WEB === bridge_getDeviceModel()) {
    return true
  }

  return isSDKCompatible(androidSDKVersion, MIN_REFUND_RECEIPTS_APK_VERSION)
}
